import { Tooltip, withStyles } from '@material-ui/core';

const CenteredTooltip = withStyles({
  tooltip: {
    textAlign: 'center',
  },
})(Tooltip);

export default CenteredTooltip;
